import UserPicker from '@ebg/vue-common/src/components/user/picker/UserPicker.vue';
import FolderTree from '@/components/folder/tree/FolderTree.vue';
import EbgSystemUserGroups from '@/components/ebgsystems/usergroups/EbgSystemUserGroups.vue'
import UserRightsInfo from '@/components/user/rights/info/UserRightsInfo.vue'
import UserRightsAttach from '@/components/user/rights/attach/UserRightsAttach.vue'

export default {
  name: 'UserRights',
  data () {
    return {
      userPickerUser: null,
      user: null,
      loadingTree: false
    };
  },
  components: {
    FolderTree,
    UserPicker,
    EbgSystemUserGroups,
    UserRightsInfo,
    UserRightsAttach
  },
  computed: {
    userPickerFilters () {
      let filters = null;
      if (this.$session.get('user')?.is_head_user_or_manager) {
        filters = { only_managed_users: true };
      }
      if (this.ApiRequest.userHasPermission('view-all-users')) {
        filters = null;
      }
      return filters;
    },
    canPickUsers () {
      return (this.ApiRequest.userHasPermission('view-all-users') ||
            this.ApiRequest.userHasPermission('view-company-users') ||
            this.$session.get('user')?.is_head_user_or_manager
      );
    },
    currentLdapUser () {
      if (this.user && parseInt(this.user.isLdapUser) === 1) {
        return true;
      }
      return false;
    },
    folderPermissions () {
      if (this.user && this.user.ad_group_permissions) {
        return this.user.ad_group_permissions.folders;
      }
      return null;
    },
    otherPermissions () {
      if (this.user && this.user.ad_group_permissions) {
        return this.user.ad_group_permissions.other;
      }
      return null;
    },
    systemPermissions () {
      if (this.user && this.user.ad_group_permissions) {
        return this.user.ad_group_permissions.systems;
      }
      return null;
    }
  },
  methods: {
    userFolderGroupsChanged (data) {
      this.user.ad_group_permissions = data;
    },
    getFullUserData (newUser) {
      if (newUser && newUser.api_id) {
        this.requestUserData(newUser.api_id);
      } else {
        // this.user = null;
        this.user = newUser;
      }
    },
    requestUserData (userApiId) {
      this.loadingTree = true;
      this.ApiRequest.request('user/get/' + userApiId, this.ApiRequest.REQUEST_GET, [], (response) => {
        if (response.data) {
          this.user = response.data
          this.userPickerUser = {
            id: this.user.id,
            fullname: this.user.fullname,
            email: this.user.email,
            isDisabled: this.user.isDisabled,
            isLdapUser: this.user.isLdapUser
          }
        }
        this.loadingTree = false;
      });
    },
    openUserRightsAttachFrm () {
      this.$refs.userRightsAttachFrm.show(this.user);
    },
    userRightsAttached (data) {
      if (this.user) {
        this.user.ad_group_permissions = data;
      }
    }
  },
  mounted () {
    const uuid = this.$route.query.user ?? this.$session.get('uuid');
    this.requestUserData(uuid);
  }
}
